import React from "react";
import { Autocomplete, TextField, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";

import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { useTranslation } from "react-i18next";

const TableFilterFields = ({
  filters,
  products,
  setFilters,
  AdapterDateFns,
  recipient
}) => {
  const { t } = useTranslation();
  return (
    <div style={{ width: "90%", margin: "auto" }}>
      <Grid container spacing={2} sx={{ marginTop: 5, marginBottom: 10 }}>
        <Grid item xs={12} sm={6} md={2} style={{ marginRight: "25px" }}>
          <Typography variant="h6" component="h6" style={{ marginBottom: 10 }}>
            {t("product")}
          </Typography>
          <Autocomplete
            value={filters.product || null}
            onChange={(e, newValue) => {
              setFilters((prev) => ({ ...prev, product: newValue || "" }));
            }}
            options={products || []}
            getOptionLabel={(option) => option?.label || option || ""}
            renderInput={(params) => (
              <TextField
                sx={{ width: "300px" }}
                {...params}
                label={t("selectProduct") || "Select Product"}
              />
            )}
            fullWidth
          />
        </Grid>
        <Grid item xs={12} sm={6} md={2} style={{ marginRight: "25px" }}>
          <Typography variant="h6" component="h6" style={{ marginBottom: 10 }}>
            {t("recipient")}
          </Typography>
          <Autocomplete
            value={filters.recipient || null}
            onChange={(e, newValue) => {
              setFilters((prev) => ({ ...prev, recipient: newValue || "" }));
            }}
            options={recipient || []}
            getOptionLabel={(option) => option?.label || option || ""}
            renderInput={(params) => (
              <TextField
                sx={{ width: "300px" }}
                {...params}
                label={t("selectRecipient")}
              />
            )}
            fullWidth
          />
        </Grid>

        <Grid item xs={12} sm={6} md={2}>
          <Typography variant="h6" component="h6" style={{ marginBottom: 10 }}>
            {t("dateFrom")}
          </Typography>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              label={t("dateFrom")}
              value={filters.dateFrom}
              onChange={(newValue) =>
                setFilters((prev) => ({ ...prev, dateFrom: newValue }))
              }
              renderInput={(params) => <TextField {...params} />}
              fullWidth
            />
          </LocalizationProvider>
        </Grid>

        <Grid item xs={12} sm={6} md={2}>
          <Typography variant="h6" component="h6" style={{ marginBottom: 10 }}>
            {t("dateTo")}
          </Typography>
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <DatePicker
              label={t("dateTo")}
              value={filters.dateTo}
              onChange={(newValue) =>
                setFilters((prev) => ({ ...prev, dateTo: newValue }))
              }
              renderInput={(params) => <TextField {...params} />}
              fullWidth
            />
          </LocalizationProvider>
        </Grid>

        <Grid item xs={12} sm={6} md={2}>
          <Typography variant="h6" component="h6" style={{ marginBottom: 10 }}>
            BE
          </Typography>
          <TextField
            label={t("filterByBENumber")}
            variant="outlined"
            value={filters.be}
            onChange={(e) =>
              setFilters((prev) => ({ ...prev, be: e.target.value }))
            }
            fullWidth
          />
        </Grid>
      </Grid>
    </div>
  );
};

export default TableFilterFields;
